export default (function () {
    var callbacks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        callbacks[_i] = arguments[_i];
    }
    return callbacks
        .filter(function (callback) { return typeof callback === 'function'; })
        .reduce(function (accumulator, callback) {
        if (accumulator === null) {
            return callback;
        }
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            accumulator.apply(null, args);
            callback.apply(null, args);
        };
    }, null);
});
//# sourceMappingURL=chainCallbacks.js.map